<template>
  <div class="bg-white sm:rounded-md sm:overflow-hidden py-6 space-y-6">
    <form>
      <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
        <div class="sm:col-span-3">
          <jet-label
            for="first_name"
            value="First Name"
          />
          <div class="mt-1">
            <jet-input
              id="first_name"
              v-model="form.first_name"
              type="text"
              class="mt-1 block w-full"
              required
              autocomplete="new-first_name"
            />
            <p
              v-if="form.errors.first_name"
              id="first_name-error"
              class="mt-2 text-sm text-red-600"
            >
              {{ form.errors.first_name }}
            </p>
          </div>
        </div>

        <div class="sm:col-span-3">
          <jet-label
            for="last_name"
            value="Last Name"
          />
          <div class="mt-1">
            <jet-input
              id="last_name"
              v-model="form.last_name"
              type="text"
              class="mt-1 block w-full"
              required
              autocomplete="new-last_name"
            />
            <p
              v-if="form.errors.last_name"
              id="last_name-error"
              class="mt-2 text-sm text-red-600"
            >
              {{ form.errors.last_name }}
            </p>
          </div>
        </div>

        <div class="sm:col-span-6">
          <jet-label
            for="email"
            value="Email"
          />
          <div class="mt-1">
            <jet-input
              id="email"
              v-model="form.email"
              type="email"
              class="mt-1 block w-full"
              required
            />
            <p
              v-if="form.errors.email"
              id="email-error"
              class="mt-2 text-sm text-red-600"
            >
              {{ form.errors.email }}
            </p>
          </div>
        </div>

        <div class="sm:col-span-3">
          <jet-label
            for="password"
            value="Password"
          />
          <div class="mt-1">
            <jet-input
              id="password"
              v-model="form.password"
              type="password"
              class="mt-1 block w-full"
              required
              autocomplete="new-password"
            />
            <p
              v-if="form.errors.password"
              id="password-error"
              class="mt-2 text-sm text-red-600"
            >
              {{ form.errors.password }}
            </p>
          </div>
        </div>

        <div class="sm:col-span-3">
          <jet-label
            for="password_confirmation"
            value="Confirm Password"
          />
          <div class="mt-1">
            <jet-input
              id="password_confirmation"
              v-model="form.password_confirmation"
              type="password"
              class="mt-1 block w-full"
              required
              autocomplete="new-password"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import JetInput from '../../Jetstream/Input.vue';
import JetLabel from '../../Jetstream/Label.vue';

export default {
  name: 'CreateAccount',

  components: {
    JetInput,
    JetLabel,
  },

  props: ['form'],
  emits: ['update:form'],

  computed: {
    form: {
      get() {
        return this.form;
      },
      set(value) {
        this.$emit('update:form', value);
      },
    },
  },

  methods: {

  },
};

</script>
